import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import ThreadList from '@components/threadList';
import UserMessageList from '@components/userMessageList';
import SystemList from '@components/systemList';
import MessageLikeAndFavoriteList from '@components/messageLikeAndFavoriteList';
import DownloadApp from '@components/downloadApp';
import SidebarTopicList from '@components/sidebarTopicList';
import SidebarUserInfo from '@components/sidebarUserInfo';
import { copy } from '@utils/copy';
import { clearAllCookies, clearStorages } from '@utils/cookie';
import Avatar from '@components/avatar';
import { BASE_IMG_URL } from '@images/imageUrls';
import Toast from '@components/Toast';
import TabNav  from '@components/tabNav';
import classNames from 'classnames';


interface RouteParams {
    code?: string;
}

interface MessagePCPageProps extends BasePageProps, RouteComponentProps<RouteParams> {
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    userInfo?: any
    handleLoadMore: any
    navList?: any
    navClick?: Function
    navCurrentIndex?: any
    navCurrentType?: any
    unreadNotificationsData?: any   // 未读消息数据
    // friendList?: any // 关注/粉丝列表
    // friendType?: any    // 关注、粉丝类型
}
interface MessagePCState { 
    loading: any
    error: any
    pageLoaded: any
    topicList?: any
    
}
@inject('app', 'site', 'user', 'thread')
@observer
class MessagePCPage extends BasePage<MessagePCPageProps, MessagePCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        topicList: [],
        // navList: [
        //     {name: '发帖', id: 0, type: '0'},
        //     // {name: '评论', id: 0, type: '1'},
        //     // {name: '点赞', id: 1, type: '2'},
        //     // {name: '收藏', id: 0, type: '3'},
        //     // {name: '勋章', id: 1, type: '4'},
        //     {name: '关注', id: 5, type: '5'},
        //     {name: '粉丝', id: 6, type: '6'},
        // ],  // tab切换列表
        // navCurrentIndex: 0, // 导航当前选中索引
        // navCurrentType: 0,  // 导航当前选中类型
        // followUserList: [], // 关注列表
        // fansUserList: [], // 粉丝列表
    };
    componentDidMount() {
        const { app, user, thread } = this.props;
        // if (user) {
        //     user.fetchUserInfo({ code: user?.userInfo?.code });
        // }
        // if (thread) {
        //     let params: any = {
        //         "page[number]": 1,
        //         "page[size]": 20
        //     }
        //     thread.getThreadList(params)
        // }
        super.componentDidMount();
    }

    // 跳转到帖子详情页
    // handleThreadClick = (id: string | number) => {
    //     this.props.history && this.props.history.push(`/threadDeatil/${id}`);
    // };

    // 点击复制
    onCopyClick = (data) => {
        copy(data);
        Toast.success({ content: '已复制社区号' });
    }

    // // 类型切换
    // navClick = (item:any) => {
    //     console.log(item, '当前')
    // }

    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        // console.log('导航点击:', { item, index });
        
        // 调用父组件传递的函数
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }
    // 消息列表（评论和@）
    renderMessageList = () => {
        const { navCurrentIndex, user, handleLoadMore } = this.props;
        if (!user || !user.listStore) return null;
        const list = user.listStore.lists['userNotificationsList'];
        if (!list) return null;
        const flatList = user.listStore.getList({ namespace: 'userNotificationsList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <UserMessageList
                    data={flatList}
                    type={navCurrentIndex}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="userNotificationsList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></UserMessageList>

            </div>
        )
    }

    // 消息的点赞和收藏列表
    renderLikeAndFavoriteList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) {
            return null;
        }
        const list = user.listStore.lists['userNotificationsList'];
        if (!list) {
            return null;
        }
        const flatList = user.listStore.getList({ namespace: 'userNotificationsList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <MessageLikeAndFavoriteList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="userNotificationsList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></MessageLikeAndFavoriteList>
            </div>
        )
    }

    // 系统通知列表
    renderSystemList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) return null;
        const list = user.listStore.lists['userNotificationsList'];
        if (!list) return null;
        const flatList = user.listStore.getList({ namespace: 'userNotificationsList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <SystemList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="userNotificationsList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></SystemList>
            </div>
        )
    }


    // 首页左侧侧内容
    readerLeft = () => {
        const { user, userInfo, navList, navCurrentIndex, navCurrentType, loading, hasMore, onLoadMore, unreadNotificationsData } = this.props;
        let isSelf = this.props.match.params?.code == user?.userInfo?.code ? true : false; // 是否是自己
        const displayNavList = isSelf ? navList : (navList || []).filter((item: any) => item?.namespace !== 'usersFavoritesList');
        const displayNavCurrentIndex = displayNavList[navCurrentIndex] ? navCurrentIndex : 0;
        console.log(displayNavCurrentIndex, '当前current')
        
        return (
            <div className={styles.leftContent}>
                <div className={styles.userDetail}>
                    {/* 用户信息 */}
                    <div className={styles.userInfoBox}>
                        <div className={styles.avatarBox}>
                            <Avatar avatarUrl={userInfo?.avatarUrl || ''} size={100} titleMark={userInfo?.titleMark} userCode={userInfo?.code} officialSize={24}></Avatar>
                        </div>
                        
                        <div className={styles.userInfoDetail}>
                            <div className={styles.nickname}>
                                {userInfo?.nickname}
                                {userInfo?.gender === 2 && <img src={`${BASE_IMG_URL}/common/woman.png`} alt="性别" className={styles.gender}/>}
                                {userInfo?.gender === 1 && <img src={`${BASE_IMG_URL}/common/man.png`} alt="性别" className={styles.gender}/>}
                            </div>
                            <div className={styles.info}>
                                {userInfo?.lastPublishSource !== '' && <span className={styles.model}>{userInfo?.lastPublishSource}</span>}
                                <span className={styles.userId} onClick={() => this.onCopyClick(userInfo?.code)}>社区号  {userInfo?.code}</span>
                            </div>
                            {userInfo?.titleList?.length > 0 && <div className={styles.userTags}>
                                {userInfo?.titleList.slice(0, 5).map((tag) => <div className={classNames(styles.tag, tag.wear ? styles.tagActive : '')}>{tag.title_name}</div>)}
                                <div className={styles.totalTags}>共{ userInfo?.titleList?.length }个头衔</div>
                            </div>}
                            <div className={styles.info}>{userInfo?.signature || '欢迎来到vivo社区，快来介绍下自己吧~'}</div>
                        </div>
                        <div className={styles.myPrivateBtnBox}>
                            <div className={styles.myPrivateBtn} onClick={() => {
                                this.props.history.push(`/privateMessage`)
                            }}>我的私信</div>
                            {unreadNotificationsData.dialogNotifications > 0 && <div className={styles.privateNum}>{unreadNotificationsData.dialogNotifications > 99 ? '99+' : unreadNotificationsData.dialogNotifications}</div>}
                        </div>
                    </div>
                </div>
                <TabNav navList={displayNavList} showRightCornerNum={true} currentIndex={displayNavCurrentIndex} isAlignLeft={true} navClick={(item:any, index:any) => this.handleNavClick(item, index)} ></TabNav>
                <div className={styles.userTabContentBox}>
                    {/* 评论和@ */}
                    {(displayNavCurrentIndex == 0  || displayNavCurrentIndex == 1) && this.renderMessageList()}
                    {/* 系统通知 */}
                    {displayNavCurrentIndex == 2  && this.renderSystemList()}
                    {/* 点赞和收藏列表 */}
                    {navCurrentType == 3  && this.renderLikeAndFavoriteList()}
                </div>
            </div>
        );
    }

    // 首页右侧内容
    readerRight = () => {
        const { user, userInfo } = this.props;
        let isSelf = this.props.match.params?.code == user?.userInfo?.code ? true : false; // 是否是自己
        // let isLogin = false;
        return (
            <div className={styles.rightContent}>
                
                {/* 下载app */}
                <DownloadApp></DownloadApp>
                {/* 用户信息 */}
                <SidebarUserInfo isShowUserDetail={false} showOtherInfo={isSelf ? false : true} otherUserInfo={userInfo}></SidebarUserInfo>
                {/* 热门话题 */}
                <SidebarTopicList></SidebarTopicList>
                
            </div>
        );
    }

    render() {
        const { app } = this.props;

        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (<div className={styles.wrapper}>
                {this.readerLeft()}
                {this.readerRight()} 
            </div>)
        }

    }
}

export default withRouter(MessagePCPage);
